import * as D from "dynein"
import {loginPage} from "./panes/loginPage";

D.createRoot(()=>{
	D.mountBody(()=>{
		loginPage()
	})
})